import React from 'react';
import {Header} from '@deere/ux.uxframe-react';

function CUTHeader(props) {
    return (
        <Header
            logoLink= {'/'}
            pageHeading="CUT Registration"
            skipLink="#content"
            pageHeadingLink={'/'}
            search={false}
            mobileMenu={`${props.mobileMenu}`}
        >

        </Header>
    );
}

export default CUTHeader
